import {
  Authenticator as AmplifyAuthenticator,
  ConfirmSignIn,
  ConfirmSignUp,
  ForgotPassword,
  Greetings,
  Loading,
  RequireNewPassword,
  SignIn,
  SignUp,
  TOTPSetup,
  VerifyContact,
} from 'aws-amplify-react';
import * as React from 'react';
import { connect } from 'react-redux';
import { Action, Actions } from 'services/authentication/ducks';
import CustomAuthWrapper from './customAuthWrapper';
import { useAppContext } from 'core/app/AppContext';

interface DispatchProps {
  amplifySignedIn: () => Action;
}

type Props = DispatchProps;

const actions: DispatchProps = {
  amplifySignedIn: Actions.amplifySignedIn,
};
export const Authenticator: React.FC<Props> = props => {
  const { setSignedIn } = useAppContext();

  const handleStateChange = (newState: any) => {
    if (newState !== 'signedIn') {
      return;
    }
    props.amplifySignedIn();
    setSignedIn(true); //See AppContext for more info on why this is needed.
  };

  return (
    <AmplifyAuthenticator
      onStateChange={handleStateChange}
      hide={[
        ForgotPassword,
        Greetings,
        ConfirmSignIn,
        SignIn,
        SignUp,
        RequireNewPassword,
        ConfirmSignUp,
        VerifyContact,
        TOTPSetup,
        Loading,
      ]}
    >
      <CustomAuthWrapper handleStateChange={handleStateChange} />
      {props.children}
    </AmplifyAuthenticator>
  );
};

export default connect(null, actions)(Authenticator);
